/*
 * AUTOGROW TEXTAREA
 * Version 1.0
 * A mooTools plugin
 * by Gary Glass (www.bookballoon.com)
 * mailto:bookballoon -at- bookballoon.com
 *
 * Based on a jQuery plugin by Chrys Bader (www.chrysbader.com).
 * Thanks to Aaron Newton for reviews and improvements.
 *
 * Copyright (c) 2009 Gary Glass (www.bookballoon.com)
 * Dual licensed under the MIT (MIT-LICENSE.txt)
 * and GPL (GPL-LICENSE.txt) licenses.
 *
 * NOTE: This script requires mooTools. Download mooTools at mootools.net.
 *
 * USAGE:
 *		new AutoGrow(element);
 * where 'element' is a textarea element. For example:
 *		new AutoGrow($('myTextarea'));
 */
var AutoGrow = new MooTools.Class({

  name: 'AutoGrow',

  Implements: [MooTools.Options, MooTools.Events],

  options: {
    margin: 0, // gap (in px) to maintain between last line of text and bottom of textarea
    minHeight: 0, // minimum height of textarea
    maxHeight: 0,
    tween: true
    /* onResize: null */
  },

  resizeRef: null,

  initialize: function(textarea, options) {
    this.setOptions(options);
    this.textarea = $(textarea);
    this.resizeRef = this.resize.bind(this);

    this.textarea.addEvent('keyup', this.resizeRef);
    this.textarea.addEvent('mouseup', this.resizeRef);

    this.options.tween && this.textarea.set('tween', {
      'duration': 150,
      'onComplete': this.fireEvent.pass(['resize'], this)
    });

    this.options.minHeight = this.textarea.clientHeight;

    this.dummy =  new MooTools.Element("div", {
      styles:	{
        "overflow-x" : "hidden",
        "position"   : "absolute",
        "top"        : 0,
        "left"       : "-9999px",
        "white-space": "pre-wrap"

          // for debugging
//        'top'        : 10,
//        'left'       : 10,
//        'background' : '#fff',
//        'z-index'    : 999999
      }
    })
    .inject(document.body);

    this.setDummyStyles();
    this.resize.delay(300, this);
  },

  setDummyStyles: function() {
    this.dummy.setStyles(this.textarea.getStyles(
      "font-size",
      "font-family",
      "font-style",
      "font-variant",
      "font-weight",
      "width",
      "line-height",
      "padding"
    ));
  },

  resize: function(pForce) {
    var html = this.textarea.get('value').replace(/\n|\r\n/g, '<br>X') + 'X';

    if (pForce || (this.dummy && this.dummy.get("html").toLowerCase() != html.toLowerCase())){
      this.dummy.set("html", html);

      var triggerHeight = this.dummy.getComputedSize().height + this.options.margin,
      newHeight = Math.max(this.options.minHeight, triggerHeight);

      if(this.options.maxHeight && newHeight > this.options.maxHeight) {
        newHeight = this.options.maxHeight;
      }

      if (this.textarea.clientHeight != newHeight) {

        if(this.options.tween) {
          this.textarea.tween("height", newHeight);
        }
        else {
          this.textarea.setStyle('height', newHeight);
          this.fireEvent('resize');
        }
      }
    }
  },

  destroy: function() {
    this.dummy.destroy();
    delete this.dummy;

    this.textarea.removeEvent('keyup', this.resizeRef);
    this.textarea.removeEvent('mouseup', this.resizeRef);
  }

});
